import { useEffect } from 'react';
import { componentFrameworkStore } from './store.js';

function useComponentFrameworkAutoDeactivation(ref, args) {
  useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        var _a, _b;
        const entry = entries[0];
        if (!entry || ((_a = args.isDisabledRef) == null ? void 0 : _a.current)) {
          return;
        }
        if (!entry.isIntersecting) {
          if (target.contains(document.activeElement) && document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }
          (_b = args.onDeactivate) == null ? void 0 : _b.call(args);
          componentFrameworkStore.dispatch(
            componentFrameworkStore.actions.deactivateComponent(
              args.componentId
            )
          );
        }
      },
      {
        rootMargin: "100px"
      }
    );
    observer.observe(target);
    return () => {
      var _a;
      observer.disconnect();
      (_a = args.onDeactivate) == null ? void 0 : _a.call(args);
      componentFrameworkStore.dispatch(
        componentFrameworkStore.actions.deactivateComponent(args.componentId)
      );
    };
  }, [args.componentId, ref]);
}

export { useComponentFrameworkAutoDeactivation };
//# sourceMappingURL=integration.auto-deactivation.js.map
